var _linearGradient;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTabatimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283.46,
    height: 283.46,
    rx: 58.11,
    style: {
      fill: "#00a14b"
    }
  })), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 143.52,
    y1: -12.45,
    x2: 138.84,
    y2: 391.29,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#75c594"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#72c492"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#68c28c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#58be82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#42b873"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#3eb771"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 283.46,
    height: 283.46,
    rx: 58.11,
    style: {
      fill: "#00a14b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 283.46,
    height: 283.46,
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.38,146.18a12.68,12.68,0,0,0,2.06,2.21h0a13.39,13.39,0,0,0,9.6,3.11,13,13,0,0,0,12.28-13.68,12.69,12.69,0,0,0-7-10.42h0l-45.84-23a4.91,4.91,0,0,0-2.7-.87,3.66,3.66,0,0,0-3.46,3.86c.08,1.16.84,1.84,1.68,2.74Z",
    transform: "translate(0)",
    style: {
      fill: "#f58e8d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.17,42.2s-5.46-.34-7.65-.34c-6.86,0-12.42,4.41-12.42,9.85a8.17,8.17,0,0,0,.16,1.48l-.16.08v33h0a12.08,12.08,0,0,0,24.1,0h0v-20A73.32,73.32,0,0,1,212,138.75c0,40.6-32.61,73.51-72.83,73.51s-72.82-32.91-72.82-73.51A73.71,73.71,0,0,1,78,98.92a11.24,11.24,0,0,0,3.37-8A11.67,11.67,0,0,0,69.49,79.44a12,12,0,0,0-9.25,4.3l-.05,0c-.15.22-.29.44-.43.66a6.64,6.64,0,0,0-.43.65A97.06,97.06,0,0,0,43.2,138.75c0,53.51,43,96.89,96,96.89s96-43.38,96-96.89C235.17,88,196.44,46.3,147.17,42.2Z",
    transform: "translate(0)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabatimer);
export default __webpack_public_path__ + "static/media/tabatimer.9c86afc8.svg";
export { ForwardRef as ReactComponent };